import { t as __t } from "i18next";
import { Link, useNavigate } from "react-router-dom";
import MobileSidebar from "./mobile-sidebar";
import Lang from "../common/dropdown-lang/dropdownLangMobile";
import { useDispatch, useSelector } from "react-redux";
import { useId, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import Swal from "sweetalert2";
import "./dashboard-shell-green.css";
import { callSearchUser } from "../../api/callcenters/service";
import UserProfileModal from "./UserProfileModal";

const MobileMenu = () => {
	const { t } = useTranslation();
	const reactId = useId();
	const offcanvasId = useMemo(
		() => `offcanvasMenu-${reactId.replace(/[^a-zA-Z0-9_-]/g, "")}`,
		[reactId]
	);
	const userInfo = useSelector((state) => state.dataLogin);
	const dispatch = useDispatch();
	const navigate = useNavigate();
	const user = userInfo?.data?.user;
	const [showProfileModal, setShowProfileModal] = useState(false);
	const [profileUser, setProfileUser] = useState(null);
	const [profileLoading, setProfileLoading] = useState(false);

	const displayName = useMemo(() => {
		return `${user?.firstName || ""} ${user?.lastName || ""}`.trim() || "G-Win";
	}, [user]);

	const initials = useMemo(() => {
		const parts = displayName.split(" ").filter(Boolean);
		return parts.slice(0, 2).map((part) => part.charAt(0).toUpperCase()).join("") || "GW";
	}, [displayName]);


	const handleOpenProfile = async () => {
		setProfileUser(user || null);
		setShowProfileModal(true);

		if (!user?.userId) return;

		setProfileLoading(true);
		try {
			const rsp = await dispatch(
				callSearchUser({
					page: 1,
					maxResult: 1,
					keyword: "",
					userId: user.userId,
				})
			);

			if (rsp?.payload?.responseCode === "00000") {
				const rows = rsp?.payload?.data?.result || [];
				const exactUser = rows.find((item) => Number(item.userId) === Number(user.userId)) || rows[0];
				if (exactUser) setProfileUser({ ...user, ...exactUser });
			}
		} catch (error) {
			console.log("Load mobile header user profile error:", error);
		} finally {
			setProfileLoading(false);
		}
	};

	const handleLogout = () => {
		Swal.fire({
			title: __t("uiText.text006"),
			text: __t("uiText.text007"),
			icon: "question",
			reverseButtons: true,
			showCancelButton: true,
			confirmButtonColor: "#3085d6",
			cancelButtonColor: "#dc2626",
			confirmButtonText: __t("uiText.text008"),
			cancelButtonText: __t("uiText.text009"),
		}).then((result) => {
			if (result.isConfirmed) navigate("/logout");
		});
	};

	return (
		<header className="main-header main-header-mobile gwin-mobile-header">
			<div className="auto-container gwin-mobile-container">
				<div className="inner-box gwin-mobile-shell">
					<div className="nav-outer gwin-mobile-brand-area">
						<div className="logo-box gwin-mobile-logo-box">
							<Link to="/admin/dashboard" className="gwin-mobile-brand-link">
								<img src="/images/lti_logo.png" alt="brand" className="header-logo gwin-mobile-logo" />
							</Link>
						</div>
						<MobileSidebar offcanvasId={offcanvasId} />
					</div>

					<div className="outer-box gwin-mobile-actions">
						<div className="gwin-mobile-lang"><Lang /></div>

						{userInfo?.data && (
							<div className="dropdown dashboard-option gwin-mobile-user-menu">
								<button
									type="button"
									className="dropdown-toggle gwin-mobile-user-trigger"
									data-bs-toggle="dropdown"
									aria-expanded="false"
									aria-label={displayName}
								>
									<span className="gwin-mobile-avatar">{initials}</span>
								</button>
								<ul className="dropdown-menu dropdown-menu-end gwin-user-dropdown">
									<li className="gwin-mobile-user-summary">
										<span className="gwin-mobile-user-name">{displayName}</span>
									</li>
									<li><hr className="dropdown-divider" /></li>
									<li>
										<button className="gwin-profile-menu-button" onClick={handleOpenProfile}>
											<i className="la la-user-circle" />
											<span>{t("callcenter.customerService.userInformation")}</span>
										</button>
									</li>
									<li><hr className="dropdown-divider gwin-user-dropdown-divider" /></li>
									<li>
										<button className="gwin-logout-button" onClick={handleLogout}>
											<i className="la la-sign-out" />
											<span>{__t("uiText.text011")}</span>
										</button>
									</li>
								</ul>
							</div>
						)}

						<button
							type="button"
							className="mobile-nav-toggler gwin-mobile-toggler"
							data-bs-toggle="offcanvas"
							data-bs-target={`#${offcanvasId}`}
							aria-controls={offcanvasId}
							aria-label={t("accessibility.openNavigation")}
						>
							<span className="flaticon-menu-1" />
						</button>
					</div>
				</div>
			</div>
			<UserProfileModal
				show={showProfileModal}
				onHide={() => setShowProfileModal(false)}
				user={profileUser}
				loading={profileLoading}
			/>
		</header>
	);
};

export default MobileMenu;
